import {Component, OnInit} from '@angular/core';
import { ConfigService } from 'src/app/core/services/config/config.service';
// import { AppComponent } from '../../../app.component';
// import { AppMainComponent } from '../../../app.main.component';

@Component({
  selector: 'app-topbar-blank',
  templateUrl: './topbar-blank.component.html',
  styleUrls: ['./topbar-blank.component.scss']
})
export class TopbarBlankComponent implements OnInit {
  siteLogo:string="";
  constructor() {
    this.siteLogo = ConfigService.APPMainsettings.SiteLogo;
  }

  ngOnInit(): void {
  }

}
